import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import translationKO from "./translation.ko.json"
import translationEN from "./translation.en.json"
import translationDE from "./translation.de.json"
import translationES from "./translation.es.json"
import translationFR from "./translation.fr.json"
import translationJP from "./translation.jp.json"
import translationPT from "./translation.pt.json"
import translationZH from "./translation.zh.json"

const resource = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKO,
  },
  de: { translation: translationDE },
  es: { translation: translationES },
  fr: { translation: translationFR },
  jp: { translation: translationJP },
  pt: { translation: translationPT },
  zh: { translation: translationZH },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: resource,
    lng: "ko",
    fallbackLng: "ko",
    // ns: ['translation'],
    // defaultNS: "translation",
    debug: false,
    keySeparator: ".", // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
